import bbps from "./bbps.png";
import logo from "./image.png";
import img from "./image (1).png";
import userlogo from "./userlogo.jpg";
import bharatConnect from "./BharatConnectPrimaryLogoSVG.svg";
import bAssured from "./B_Assured_Logo_SVG.svg";
import frontBanner from "./hero mockup.png";
import footerMockup from "./footermockup.png";
import footerMockupLight from "./footermockup_light.png";
import authMockup from "./login and reg.png";
import headerLogo from "./CQ1 header1.png";
import footerLogo from "./CQ2-footer.png";
import Bmnemonic from "./B_mnemonic_PNG_blue.png";

export const images = {
  bbps,
  logo,
  img,
  userlogo,
  bAssured,
  bharatConnect,
  frontBanner,
  footerMockup,
  footerMockupLight,
  authMockup,
  headerLogo,
  footerLogo,
  Bmnemonic,
};

export {
  logo,
  bbps,
  img,
  userlogo,
  bharatConnect,
  bAssured,
  frontBanner,
  footerMockup,
  footerMockupLight,
  authMockup,
  headerLogo,
  footerLogo,
  Bmnemonic,
};
